export enum DiscountScope {
    EACH_CONSOLIDATED_OWNER = 'EACH_CONSOLIDATED_OWNER'
}

export enum DiscountActionType {
    FIXED_UNIT_PRICE_CENTS = 'FIXED_UNIT_PRICE_CENTS'
}

export enum SubscriberType {
    COMPANY = 'COMPANY',
    PERSON = 'PERSON',
    ALL = 'ALL'
}